import commonConfig from "./common.config";

export default {
  ...commonConfig,
  dailyPlatformUrl: 'https://frontm.daily.co/',
  daily_baseUrl: 'https://gq2d9i1b2c.execute-api.us-east-1.amazonaws.com/item/video',
  xApiKey: 'ct2RRjDCuK5nj3J6Sgqv41aqUJ2EtZShiqPrQ7sb',
  userImageBaseUrl: "https://gw.frontm.ai/proxy/resource/file/profile-pics",
  defaultHomePagebaseUrl: "spinnet5.frontm.ai",
  googleClientId: '834750737902-mve86aq37ndgevoi7qmpn99tbuulma8u.apps.googleusercontent.com',
  jwtLoginURL: 'https://8ojwj18vtd.execute-api.us-east-1.amazonaws.com/prod',
  xApiKeyForJwtLogin: 'ct2RRjDCuK5nj3J6Sgqv41aqUJ2EtZShiqPrQ7sb',
  wpsGatewayRestApiKey: "https://api.frontm.ai/v5",
  websocketURL : 'wss://fffsczccvc.execute-api.us-east-1.amazonaws.com/production',
  webSocketAPiKey : 'ct2RRjDCuK5nj3J6Sgqv41aqUJ2EtZShiqPrQ7sb',
  //Apptypes
  vikandWebAppType: "vikand",
  stationoneAppType: "stationsatcom",
  onshipAppType: "onship",
  seamedexAppType: "seamedix",
  seadanceAppType: "seadance",
  intelsatAppType: "intelsat",
  crewmattersAppType: "crewmattersplus",
  //authCode
  onshipDomain: 'onshipEndUser',
  crewMattersDomain: '1s!eOF@3n',
  getBotLogoUrl:'https://s3.amazonaws.com/592975064982-frontm-contentdelivery-production/botLogos/',

  //webPushKeys
  seamedexWebPushKey: 'BJAgyasngZG5ecr4Dvq-eonxZc2WfMnunzZ8UESlv6oDee-Az81B6gXAh80JZOL0zkr3SdkmxbodX56vLyaJdcU',
  vikandWebPushKey: 'BCC9TlmesdLmBIYUUYhhu8Df0angc2g6tf8zY9BlUnvQavMYrrAp9ZnsKz_UzQ-aC1_EOEtg4JQMqjNPuKc-t-g',
  dailyXApiKey:"K3a5bY5AwJ6PkiJVqCVAPadnpySgxSR68IPP3SYC",
  
};
